import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {UserService} from "../../../services/user.service";
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import firebase from 'firebase';
import { TranslationService } from '../../../services/translation.service';
import {WalletService} from "../../../services/wallet.services";
import { ExcelService } from '../../../services';

import { RecipeBean } from '../../../beansts/recipe.bean';

declare let $: any;
declare let Swal:any;

@Component({
    selector : 'edit-room-modal',
    templateUrl:'edit-room-component.html'
})
export class EditRoomComponent implements OnInit, OnDestroy{

  public src2d;
  public srcPhoto;
  public selectIdx;
  public companyItens

  public spaces

  public backgroundType='2D';
  public images=[];
  public room;
  public roomDataForm : FormGroup;
  public roomBackgroundForm : FormGroup;
  public vecBackgroundForm=[]
  public background2dForm: FormGroup;
  public background3dForm : FormGroup;
  public hasModel=false;
  public matterPortForm=[]

  public mapForm : FormGroup;

  public myIdx=0;
  public item;

  public texture;
  public category;
  public textureName;
  public imageStr
  public color='red';
  public editMap=false;
  public editing=false;

  public textureBackground;
  public imageBackground;
  public imageToChange;

  public multiple=false;
  public admin;

  public cube;
  public packs=[]
  public pack;
  public recipes=[]

  public transitionEdit=false;
  public constructor( private excelServie: ExcelService,private _router : Router,public translate: TranslationService,public _walletService: WalletService,private _auth : UserService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
/*

*/
    }

    public transitions=[]
    public transition=null;
    public mySpaces;
    public spaceList;
    public areaSearch=false;
    public transitionBack(){
      this.areaSearch=false
    }
    public deleteTransition(tr){
      this._appData.room.backgroundPhoto.filter(v=>{
        if (v.id==this._appData.instagramUser.space){
          v.transitions=v.transitions.filter(t=>{
            return t.idx!=tr.idx
          })
        }
      })
      this.transitions=this.transitions.filter(t=>{
        return t.idx!=tr.idx
      })
      this._companyService.updateRoom(this._appData.room)
      let space=this._appData.room.backgroundPhoto.filter(v=>{
        return v.id==this._appData.instagramUser.space
      })
      this.sendIframeMessage({kind:"updatePhotoBackground",data:space[0],idx:this._appData.instagramUser.space,delete:true});

    }
    public addTransition(){
      this.transition={
        idx:'',
        x:0,
        y:0,
        z:0,
        rx:0,
        ry:0,
        rz:0,
        sx:0,
        sy:0,
        sz:0,
        nextAngle:0,
        name:''
      }
      this.spaceList=[]
      for (let obj in this.mySpaces){
        this.spaceList.push(this.mySpaces[obj]);
      }
      this.areaSearch=true;
    }
    public editTransition(t){
      this.transition=t
      this.spaceList=[]
      for (let obj in this.mySpaces){
        if (this.mySpaces[obj].id==t.idx){
          this.mySpaces[obj].selected=true;
        }
        this.spaceList.push(this.mySpaces[obj]);
      }
      this.areaSearch=true;
    }
    public selectSpace(space){
      this.transition.idx=space.id;
      this.transition.name=space.name ? space.name : '';
      let hasT=false;
      let filt=this._appData.room.backgroundPhoto.filter(t=>{
        if (t.id==this._appData.instagramUser.space){
          t.transitions.forEach(t=>{
            if (t.idx==this.transition.idx){
              hasT=true;
              t=this.transition;
            }
          })     
          if (!hasT){
            t.transitions.push(this.transition)
          }           
        }        
      })
      this._companyService.updateRoom(this._appData.room)
      let spacef=this._appData.room.backgroundPhoto.filter(v=>{
        return v.id==this._appData.instagramUser.space
      })
      this.sendIframeMessage({kind:"updatePhotoBackground",data:spacef[0],idx:this._appData.instagramUser.space});

      this.transitionEdit=false;
      this.editTransitions();

    }
    public editTransitions(){
      this.areaSearch=false

      this.transitionEdit=!this.transitionEdit
      if (this.transitionEdit){
        this.transitions=[]

        if (this._appData.room.backgroundPhoto){
          if (!this.mySpaces){
            this.mySpaces={}
            if (this._appData.room.backgroundPhoto){
              this._appData.room.backgroundPhoto.forEach(v=>{
                this.mySpaces[v.id]=v
              })
            }
            if (this._appData.room.background3d){
              this._appData.room.background3d.forEach(v=>{
                this.mySpaces[v.id]=v
              })
            }
          }
          let mySpaces=this.mySpaces;
          let space=mySpaces[this._appData.instagramUser.space];
          space.transitions.forEach(v=>{
              v.spaceThumbnail=mySpaces[v.idx].psma ? mySpaces[v.idx].psma : mySpaces[v.idx].img
              v.name=mySpaces[v.idx].name ?  mySpaces[v.idx].name : ''
              this.transitions.push(v)
          })
        
          
        }

      }
    }
    public editMedia(){
      $('#roomMediaControlModal').modal('show')
    }
    public setupItemSpaces(st){
      let notst=!st;
      this._companyService.getUserRoomItemRef(this._appData.room.id).where('static','==',notst).get().then(v=>{
        v.forEach(it=>{
          let item=it.data()
            item.static=st
            this._companyService.getUserRoomItemRef(this._appData.room.id).doc(item.objectId).set(item) 
        })
      })
    }

    public getThumbnail(item){
      let thumb=item.thumbnail;
      if (thumb.indexOf('i2d')==0){
        let idx=Number(thumb.substring(4))
        thumb=this._appData.room.textures.icons[idx].i2d
      }
      if (thumb.indexOf('i3d')==0){
        let idx=Number(thumb.substring(4))
        thumb=this._appData.room.textures.icons[idx].i3d
      }
      return thumb;
    }
    public ngOnInit(): any {
      this.roomDataForm = this.fb.group({
        company : '',
        gamepath: '',
        roomName:'',
        videoBackground:'',
        imageBackground:'' 
      });
    this.mapForm = this.fb.group({
      latitude : 0,
      longitude: 0,
      price:0,
      neighbour:'',
      name:'',
      city:'',
      icon:'',
    });

    this.roomBackgroundForm = this.fb.group({
      x :0,
      y:0,
      x0:0,
      y0:0,
      x1:0,
      y1:0,
      background:'',     

    });

    this._companyService.getRecipesRef(this._appData.event).doc('BASECUBE').get().then(val => {
        let rec = val.data();
        let recipe=new RecipeBean();
        recipe.parse(rec);
        let item=recipe.toItem();
        this.cube=item;

    })

    this.reloadData();

    }

    public uploadExcel(event: any) {
      /* wire up file reader */
      const target: DataTransfer = <DataTransfer>(event.target);
      if (target.files.length !== 1) {
        throw new Error('Cannot use multiple files');
      }
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(target.files[0]);
      reader.onload = (e: any) => {
        /* create workbook */
        const binarystr: string = e.target.result;
        let data=this.excelServie.read(binarystr, { type: 'binary' })
        event.target.value = '';
        let background=[]
        let collisions=[]
        data.forEach(line=>{
          let l=line;
          let collision={}
          //collisions
          if (l['csx']!=-1){
            collision={
            x:l['csx'],
            y:l['csy'],
            v:1,
            w:l['csw'],
            h:l['csh']
            }
            collisions.push(collision)
          }
          if (l['cix']!=-1){
            collision={
              x:l['cix'],
              y:l['ciy'],
              v:1,
              w:l['ciw'],
              h:l['cih']
            }
            collisions.push(collision)
        }
        if (l['cex']!=-1){

          collision={
            x:l['cex'],
            y:l['cey'],
            v:1,
            w:l['cew'],
            h:l['ceh']
          }
          collisions.push(collision)
        }
        if (l['cdx']!=-1){

          collision ={
            x:l['cdx'],
            y:l['cdy'],
            v:1,
            w:l['cdw'],
            h:l['cdh']
          }
          collisions.push(collision)
        }

          let transitions=[]
          if (l['sid']!=-1){
            transitions.push({
              x:l['sx'],
              y:l['sy'],
              z:l['sz'],
              idx:l['sid']
            })            
          }
          if (l['eid']!=-1){
            transitions.push({
              x:l['ex'],
              y:l['ey'],
              z:l['ez'],
              idx:l['eid']
            })            
          }
          if (l['iid']!=-1){
            transitions.push({
              x:l['ix'],
              y:l['iy'],
              z:l['iz'],
              idx:l['iid']
            })            
          }

          if (l['did']!=-1){
            transitions.push({
              x:l['dx'],
              y:l['dy'],
              z:l['dz'],
              idx:l['did']
            })            
          }


          background.push({
            x:l['x'],
            y:l['y'],
            x0:l['x0'],
            y0:l['y0'],
            x1:l['x1'],
            y1:l['y1'],
            photo:{
              img:l['img'],
              simg:l['simg'],
              kind:'sphere',
              ra:l['ra'],
              ry:l['ry'],
              transitions:transitions
            }

          })
          //
        })
        this.room.background=background;
        this.room.collisions=collisions;

        this._companyService.getRoom(this.room.id).set(this.room).then(v=>{
          var iframe = document.getElementById('gameFrame');
          if (iframe == null) return;
          var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
          iWindow.postMessage({kind:"updateBackground",data:false}, "*"); 
          Swal.fire({title:'Atualizado',message:'Excel processado com sucesso'})
        })
      };
   }

    public addForm(){
      if (!this.room.spaces){
        this.room.spaces=[]
      }
      let length=this.room.spaces.length;

      this.vecBackgroundForm.push({form:this.fb.group({
        x0 :0,
        y0:0,
        x1 :0,
        y1:0,
        spa:length
        }),transitions:[]})

        this.myIdx=length;
        this.room.spaces.push({x0:0,y0:0,x1:0,y1:0,idx:length})
    }


    public transferItens(tokenId){
      this._companyService.getUserRoomItemRef(this.room.id).where('owner','==',this._appData.instagramUser.uid).get().then(v=>{
        let itens=[]
        v.forEach(it=>{
          let item=it.data();
          if (item.tokenId==tokenId){
            itens.push(it.data())
          }
        })
        this._appData.toTransferList=itens;
        Swal.fire({
          title:'Você possui '+itens.length+' itens para transferir',
          text:'Selecione na sua lista de contatos para quem você deseja transferir os itens'
        })
        this._appData.cellScreen='contatos'
        this._appData.toggleCellPhone=true;
        $('#editRoomModal').modal('hide')
      })

    }
    public tokenize(){
      let room=this._appData.room;
      let tokenId=""
      let item={
        action:'terrain',
        objectId:'r'+room.id,
        name:room.roomName,
        collision:false,
        color:'rgb(0,0,0,0)',
        cost:0,
        dimension:{x:0.1,y:0.1,z:0.1},
        equipped:false,
        event:this._appData.event.id.toString(),
        kind:'terrain',
        location:'bag',
        owner:this._appData.instagramUser.uid,
        masterpiece:false,
        orientation:0,
        quantity:1,
        reach:1,
        room:room.id,
        src:'',
        param:{room:room.id},
        thumbnail:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Fmaps%2Fconstruct.png?alt=media&token=1b0d8c71-0dbf-4c06-9ecc-ccae1cbd0fe2',
        thumbnailAnimation:false,
        thumbnailBig:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Fmaps%2Fconstruct.png?alt=media&token=1b0d8c71-0dbf-4c06-9ecc-ccae1cbd0fe2',
        thumbnailColumn:1,
        thumbnailRow:1,
        thumbnailSrc:'',
        tokenId:tokenId
      }
      if (room.block){
        item.tokenId="9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP"
        item.thumbnail="https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Fmaps%2Fconstruct.png?alt=media&token=1b0d8c71-0dbf-4c06-9ecc-ccae1cbd0fe2"
        item.thumbnailBig="https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Fmaps%2Fconstruct.png?alt=media&token=1b0d8c71-0dbf-4c06-9ecc-ccae1cbd0fe2"
        item.dimension={x:0.1,y:0.1,z:0.1}
      }
      else{
        item.tokenId="EHEZapCQKxhBBuRRLFnssNQbCaVHv2XR7LAEryLx5ENc"
        item.thumbnail="https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Fpredios%2Fundefined_1629409608261?alt=media&token=3d719bb2-4199-4f5e-8b72-9489956982c0"
        item.thumbnailBig="https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Fpredios%2Fundefined_1629409608261?alt=media&token=3d719bb2-4199-4f5e-8b72-9489956982c0"
        item.dimension={x:10,y:10,z:1}
        item.reach=5
      }

      this._walletService.makeTokenTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',item.tokenId,1,item,null,null,this._appData.instagramUser.uid,'user-container').subscribe(wa=>{
        if (wa.status==200){         
            Swal.fire({title:"Sucesso",
                  text:"Criado",
                  confirmButtonText:"OK",
                  showCloseButton: true,
                  showCancelButton: true,
                  focusConfirm: false, 
                  }).then((result) => {
                });     
        }
        else{
          Swal.fire({title:'erro',text:'erro'})
        }
      },err=>{
        Swal.fire({title:'erro',text:err})

      })
    }
    public toggleEditing(editing){
      this.editing=editing;
      this._appData.edit=editing;
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage({kind:"roomEdit",object:editing}, "*");
      
//      $('#editObjectReload').click();
  //    $('#editObjectModal').modal('show');

    }
    public reloadData(){


      if (this._appData.instagramUser.uid=="T6sKpIAzwlPlYmEGgy2FuolQ2wN2"){
        this.admin=true;
      }

      if (!this._appData.room){
        return;
      }
      if (this._appData.room.spaces && this._appData.room.spaces.length>0){
          let x=this._appData.instagramUser.position.x
          let y=this._appData.instagramUser.position.y
          this.myIdx=0;
          let idx=0
          this._appData.room.spaces.forEach(b=>{
            if (b.x0<=x && b.y0<=y && b.x1>x && b.y1>y){
              this.myIdx=idx;
            }
            idx++;
          })
          
      }


      this.item=this._appData.object;
      this._appData.object=null;
      if (!this.item){
        this.multiple=true

      }
      else if (this.item.properties.tokenId=='9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP'){//map terrain
        this.multiple=true

      }
      else {//building terrain
        this.multiple=false

      }
      if (this._appData.param && this._appData.param.kind=='editMap'){
        this.mapForm = this.fb.group({
          latitude : this._appData.param.position.lat(),
          longitude: this._appData.param.position.lng(),
          neighbour:'',
          city:'',
          name:'',
          price:0,
          icon:'',
        });
        this.editMap=true;
        this._appData.param=null
      }
      else{
        this.editMap=false;

        this.room=this._appData.room;
        if (this.room){

          if (this.room.backgroundPhoto){
            this.spaces=this.room.backgroundPhoto
            let myid=this._appData.instagramUser.space;
            if (myid>=this.room.backgroundPhoto.length){
              myid=0;
            }
            this._appData.spaceToEdit=myid
            $('#editSpace').click();
          }

            this.roomDataForm = this.fb.group({
              company : this.room.company,
              gamepath: this.room.gamepath,
              roomName:this.room.roomName,
              videoBackground:this.room.videoBackground,
              imageBackground:this.room.photoBackground 
            });
            this.imageBackground=this.room.photoBackground   
            if (this.room.spaces){
              this.vecBackgroundForm=[]
              this.room.spaces.forEach(v=>{
                let spa=v.spa;
                let spastr=''
                if (spa){
                  spa.forEach(t=>{
                    spastr=spastr+t.toString()+','
                  })
                  spastr=spastr.substring(0,spastr.length-1);
                }

                let data={
                  x0 :v.x0,
                  y0:v.y0,
                  x1 :v.x1,
                  y1:v.y1,
                  spa:spastr
                }
               
                this.vecBackgroundForm.push({form:this.fb.group(data),transitions:{}})

              })
            }


        }
      }
      if (this.room.company){
        this.getCompanyItens();
      }

      if (this.room.user){
        this.packs=[]
        this._companyService.getUserPacks().where('uid','==',this.room.user).get().then(v=>{
          v.forEach(i=>{
            let pack=i.data();
            if (pack.recipes.length>0){
              this.packs.push(pack)
            }
          })
        })
      }

    }
    public selectPack(pack){
      this.pack=pack;
      let filter=this.packs.filter(r=>{
        return r.id==pack
      })
      if (filter.length>0){
        this.recipes=filter[0].recipes;
      }
      else{
        this.recipes=[]
      }
    }
    public calculateItemPosition(item){
      let myx=this._appData.instagramUser.position.x
      let myy=this._appData.instagramUser.position.y
      let myz=this._appData.instagramUser.position.z
      let idx=0;

      
      if (this._appData.room.backgroundPhoto){
            item.space=this._appData.instagramUser.space
            item.position={x:0,y:0,z:0}
      }
      else if (this._appData.room.ar){
        item.space=0
        item.position={x:0,y:0,z:0}
        item.kind="AR"
      }
      else{
        item.position={x:0,y:0,z:0}
        item.space=this._appData.instagramUser.space
        if (this._appData.instagramUser.position.x){
          if ((this._appData.instagramUser.position.x-this._appData.room.defaultPlace.x)>500){
            item.position.x=this._appData.room.defaultPlace.x
            item.position.y=this._appData.room.defaultPlace.y
            item.position.z=this._appData.room.defaultPlace.z ? this._appData.room.defaultPlace.z : 0
          }
          else{
            item.position.x=this._appData.instagramUser.position.x
            item.position.y=this._appData.instagramUser.position.y
            item.position.z=this._appData.instagramUser.position.z ? this._appData.instagramUser.position.z : 0
          }
        }
        else{
          item.position.x=this._appData.room.defaultPlace.x
          item.position.y=this._appData.room.defaultPlace.y
          item.position.z=this._appData.room.defaultPlace.z ? this._appData.room.defaultPlace.z : 0
        }

      }

      if (item.space==null || item.space==""){
        item.space=0
      }
      return item;
    }
    public dropItem(it){
      this._companyService.getCompanyContainerRef().doc(it.objectId).update({'room':this._appData.room.id}).then(up=>{
        it.quantity=1;
        it.room=this._appData.room.id
        it=this.calculateItemPosition(it)
        this._companyService.getUserRoomItemRef(this._appData.room.id).doc(it.objectId).set(it).then(r=>{
          Swal.fire({title:'Sucesso',text:'Item adicionado a sala'})
          this.getCompanyItens();
        })
      })

    }
    public makeItem(recipe){
      let item;
      if (recipe){
        let rec=new RecipeBean()
        rec.parse(recipe);
        item=rec.toItem();
      }
      else{
        item=this.cube;
        let date=new Date();
        item.objectId=date.getTime().toString()
      }
      let it=item.toDB();
      it.quantity=1;
      it.room=this._appData.room.id
      it=this.calculateItemPosition(it)
      it.space=this._appData.instagramUser.space;
      this._companyService.getUserRoomItemRef(this._appData.room.id).doc(it.objectId).set(it).then(r=>{
        $('#itemManipulationModal').modal('show')
     
      })

    }
    public solveBugs(){
      let i=0
      this._appData.room.textures.icons.forEach(v=>{
        v.id=i;
        i++
      })
      this._companyService.updateRoom(this._appData.room)
    }
  public sendIframeMessage(messageKind) {

		const event = new CustomEvent('angularMessage',{detail:messageKind});
		window.dispatchEvent(event);
  }

    public getCompanyItens(){
      this._companyService.getCompanyContainerRef().where("room","==","").get().then(val=>{
        let itens={}
        val.forEach(v=>{
          let it=v.data();
          let hasItem=itens[it.recipeId]
          if (hasItem){
            hasItem.quantity=hasItem.quantity+1;

          }
          else{
            hasItem=it
            hasItem.quantity=1
          }
          itens[it.recipeId]=hasItem;
        })
        this.companyItens=[]
        for (let prop in itens){
          this.companyItens.push(itens[prop])
        }
      })
    }

    public editCollision(){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage({kind:"setRoomGrid",gridEditValue:1,type:'collisions'}, "*");
    }
    public saveCollision(){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage({kind:"setRoomGrid",gridEditValue:0,type:'collisions'}, "*");
     
    }
    public eraseCollision(){
      this.room.collisions=[]
      this._companyService.getRoom(this.room.id).set(this.room)
     
    }

    public editTransparency(){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage({kind:"setRoomGrid",gridEditValue:1,type:'transparencies'}, "*");
    }
    public saveTransparency(){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage({kind:"setRoomGrid",gridEditValue:0,type:'transparencies'}, "*");
    }
    public chooseColor(color){
      this.color=color
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage({kind:"setRoomGrid",gridEditValue:color,type:'localTalks'}, "*");

      
    }
    public saveColor(){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage({kind:"setRoomGrid",gridEditValue:0,type:'localTalks'}, "*");
    }
    public updateMap(){
      let latitude=this.mapForm.controls['latitude'].value;
      let longitude=this.mapForm.controls['longitude'].value;
      let price=this.mapForm.controls['price'].value;
      let address=this.mapForm.controls['name'].value;
      let city=this.mapForm.controls['city'].value;
      let neighbour=this.mapForm.controls['neighbour'].value;

      let date=new Date();
      let milis=date.getTime();
      let id=milis.toString();
      let token='9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP'
  
      fetch('https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Fmaps%2Ftrade.png?alt=media&token=5a26bc2c-371b-4b4e-9c00-e882a2793020').then(response=>{
        response.blob().then(data=>{
              let metadata = {
                type: 'image/png'
              };
              let file = new File([data], "trade.png", metadata);
              let date=new Date();
              let newfile = id+'.png';
              $('#uploadingModal').modal("show");
              this._auth.uploadToFirebase(file, newfile, 'events/'+this._appData.event.id.toString()+'/'+token).subscribe(snapshot =>{
                snapshot.ref.getDownloadURL().then(url => {
                  let icon=url
                  if (!price) price=100;
            
                    this._walletService.makeNFT(null,null,address,id,icon,{
                      latitude:latitude,
                      longitude:longitude,
                      address:address,
                      id: id,
                      map:this._appData.event.id,
                      room:id,
                      background:url,
                      tokenId:token
                    },token).subscribe(v=>{
                      let mint_address;
                      try{ 
                        mint_address=JSON.parse(v['_body']).nft.mint.address
                      }
                      catch (err){
            
                      }
                      this._companyService.getMapPointsRef(this._appData.event.id.toString()).doc(id).set({
                        id:id,
                        room:id,
                        nft:mint_address,
                        location: new firebase.firestore.GeoPoint(latitude,longitude),
                        icon:icon,
                        price:price,
                        token:token,
                        city:city,
                        neightbour:neighbour, 
                        name:address,
                        block:1,
                        owner:''
                      }).then(m=>{
                        this._companyService.getRoom(id).set({
                          collisions:[],
                          company:'T6sKpIAzwlPlYmEGgy2FuolQ2wN2',
                          defaultPlace:{x:1,y:1},
                          event:'1592880902713',
                          nft:mint_address,
                          gamepath:'wss://viplista.com.br/ws/',
                          id:id,
                          jitsiServer:'viplistas.com.br',
                          localTalks:[],
                          name:'empty',
                          shift:{x:0,y:0},
                          nonisometric:true,
                          map:{lat:latitude,lng:longitude},
                          roomLimit:40,
                          roomName:address,
                          roomObjects:[],
                          scale:{x:1,y:1,z:1},
                          template:false,
                          textures:{background:''},
                          transparency:[],
                          video:''
                        }).then(q=>{
                          let domain=window.location.origin
                          window.location.href=domain+"/map/"+this._appData.event.id+'?lat='+latitude+'&lng='+longitude;  
                        })
              
                      })
                
               
                    })
            
              })   
          });
        });
      });
      
      


    }

    public setPosition(){
      let positionx=this._appData.instagramUser.position.x
      let positiony=this._appData.instagramUser.position.y
      this._appData.room.defaultPlace.x=positionx
      this._appData.room.defaultPlace.y=positiony
      this._companyService.getRoom(this._appData.room.id).set(this._appData.room).then(v=>{
        Swal.fire({title:'Posicao',text:'Posicao atualizada'})
      })

    }
    public makeTerrain(){
      $('#editRoomModal').modal('hide')
      Swal.fire({title:'Nome do Terreno',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: this.translate.instant('SAVE'),
      showLoaderOnConfirm: true,
      preConfirm: (name) => {
        if (name){
          let date=new Date();
          let milis=date.getTime();
          let id=milis.toString();
          let token='EHEZapCQKxhBBuRRLFnssNQbCaVHv2XR7LAEryLx5ENc'
      
          fetch('https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Fpredios%2Fterreno.png?alt=media&token=c4efd805-1e7f-4cc6-8700-7e9a77d84285').then(response=>{
            response.blob().then(data=>{
                  let metadata = {
                    type: 'image/png'
                  };
                  let file = new File([data], "trade.png", metadata);
                  let date=new Date();
                  let newfile = id+'.png';
                  this._auth.uploadToFirebase(file, newfile, 'events/'+this._appData.event.id.toString()+'/'+token).subscribe(snapshot =>{
                    snapshot.ref.getDownloadURL().then(url => {
                      let icon=url
                      if (!this._appData.instagramUser.x) {this._appData.instagramUser.x=0}
                      if (!this._appData.instagramUser.y) {this._appData.instagramUser.y=0}
                
                        this._walletService.makeNFT(null,null,name,id,icon,{
                          x:this._appData.instagramUser.x,
                          y:this._appData.instagramUser.y,
                          address:name,
                          id: id,
                          map:this._appData.event.id,
                          father:this._appData.room.id,
                          room:id,
                          background:url,
                          tokenId:token
                        },token).subscribe(v=>{
                          let mint_address;
                          try{ 
                            mint_address=JSON.parse(v['_body']).nft.mint.address
                          }
                          catch (err){
                
                          }
                            this._companyService.getRoom(id).set({
                              collisions:[],
                              company:'T6sKpIAzwlPlYmEGgy2FuolQ2wN2',
                              defaultPlace:{x:1,y:1},
                              event:'1592880902713',
                              nft:mint_address,
                              gamepath:'wss://viplista.com.br/ws/',
                              id:id,
                              father:this._appData.room.id,
                              fatherLocation:{x:this._appData.instagramUser.position.x,y:this._appData.instagramUser.position.y},
                              jitsiServer:'viplistas.com.br',
                              localTalks:[],
                              name:'empty',
                              shift:{x:0,y:0},
                              nonisometric:true,
                              roomLimit:40,
                              roomName:name,
                              roomObjects:[],
                              scale:{x:1,y:1,z:1},
                              template:false,
                              textures:{background:''},
                              transparency:[],
                              video:''
                            }).then(q=>{
                              Swal.fire({title:"Sucesso",
                              text:this.translate.instant('PURCHASE_TERRAIN_MODAL_09'),
                              confirmButtonText:this.translate.instant('OK'),
                              showCloseButton: true,
                              showCancelButton: true,
                              focusConfirm: false, 
                              }).then((result) => {
                                      let domain=window.location.origin
                                      window.location.href=domain+"/gameevent/"+this._appData.event.id+"?room="+id;                           
                            });     
            
                            })
                  
                          
                    
                   
                        })
                
                  })   
              });
            });
          });
        }
      }
      })














    }
    public updateData(){
      let company=this.roomDataForm.controls['company'].value;
      let gamepath=this.roomDataForm.controls['gamepath'].value;
      let roomName=this.roomDataForm.controls['roomName'].value;
      let videoBackground=this.roomDataForm.controls['videoBackground'].value;
      this.room.videoBackground=videoBackground;

      this.room.company=company
      this.room.gamepath=gamepath
      this.room.roomName=roomName
      this._companyService.updateRoom(this.room);
      this._appData.room=this.room;
      Swal.fire("Dados atualizados","Algumas modificações requerem reload para terem efeito.")
      //may need to update my item if i own it.
      this.updateMyItem();

    }
    public updateMyItem(){
      try{
        let filtered=this._appData.userEventContainer.filter(it=>{
          return (it.param.room==this._appData.room.id && it.tokenId=='9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP')
        })
        let it=filtered[0]
        it.name=this._appData.room.roomName;
  //      if (this._appData.room.textures.background){
    //      it.thumbnail=this._appData.room.textures.background;
     //   }
        this._companyService.getUserContainerRef().doc(it.objectId.toString()).set(it.toDB());
        this._companyService.getUserContainer(true);
  
      }
      catch (err){}

    }

    public updateBackground(i){
      let x0=0;
      let y0=0;
      let x1=0;
      let y1=0;
      let background='';
      x0=this.vecBackgroundForm[i].form.controls['x0'].value;
      y0=this.vecBackgroundForm[i].form.controls['y0'].value;
      x1=this.vecBackgroundForm[i].form.controls['x1'].value;
      y1=this.vecBackgroundForm[i].form.controls['y1'].value;
      let spastr=this.vecBackgroundForm[i].form.controls['spa'].value;
      let spa=spastr.split(',')
 
      this.room.spaces[i].x0=x0
      this.room.spaces[i].y0=y0;         
      this.room.spaces[i].x1=x1
      this.room.spaces[i].y1=y1;         
      this.room.spaces[i].spa=spa;         


      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage({kind:"updateBackground",data:this.room.spaces[i],idx:i}, "*");
    }
    public makeKey(){
      $('#editRoomModal').modal('hide');
      if (this._appData.room.key){
        let vet=this._appData.eventRecipes.filter(v=>{
          return v.id=='1640530071119'
        })
        let rec=vet[0]
        let baseItem=rec.toItem()
        baseItem.name=this._appData.room.key
        Swal.fire({
          title: 'Transferindo',
          text: 'Aguarde enquanto a receita do item esta sendo criada',
          imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
          showConfirmButton: false
        })
        this._walletService.makeTokenTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',rec.tokenId,1,baseItem.toDB(),null,null,this._appData.instagramUser.uid,'user-container').subscribe(wa=>{
          Swal.close()
          this._appData.userEventContainer.push(baseItem);
          Swal.fire("Chave feita","Chave feita e posta em sua mochila")
        },err=>{
          Swal.close()
          Swal.fire('Falha','Ouve uma falha na criação do token para sua carteira. Tente de novo')
        }) 

      }
      else{
      Swal.fire({
        title: 'Criar chave',
        text: 'Digite o nome da chave',
        input:'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'OK',
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then ((result)=>{
        if (result.value){
          

          let vet=this._appData.eventRecipes.filter(v=>{
            return v.id=='1640530071119'
          })
          let rec=vet[0]
          let baseItem=rec.toItem()
          baseItem.param={room:this._appData.room.id};
          baseItem.name=result.value
          Swal.fire({
            title: 'Transferindo',
            text: 'Aguarde enquanto a receita do item esta sendo criada',
            imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
            showConfirmButton: false
          })
          this._walletService.makeTokenTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',rec.tokenId,1,baseItem.toDB(),null,null,this._appData.instagramUser.uid,'user-container').subscribe(wa=>{
            Swal.close()
            this._appData.userEventContainer.push(baseItem);
            this._appData.room.key=result.value
            this._companyService.getRoom(this._appData.room.id).set(this._appData.room);
            Swal.fire("Chave feita","Chave feita e posta em sua mochila") 
          },err=>{
            Swal.close()
            Swal.fire('Falha','Ouve uma falha na criação do token para sua carteira. Tente de novo')
          }) 


        }
  
      })
    }
  }
  public SwitchTo(str){
    this.backgroundType=str;

  }


  public chooseModel(idx){
    this.srcPhoto=this.room.background3d[idx].img;
    this.selectIdx=idx;
    this.hasModel=true

    this.background3dForm = this.fb.group({
      x : this.room.background3d[idx].x,
      y: this.room.background3d[idx].y,
      z : this.room.background3d[idx].z,
    });
  }
  public updateModelBackground(){
    let x=this.background3dForm.controls['x'].value;
    let y=this.background3dForm.controls['y'].value;
    let z=this.background3dForm.controls['z'].value;

    this.room.background3d[this.selectIdx].y=y;         
    this.room.background3d[this.selectIdx].x=x;         
    this.room.background3d[this.selectIdx].z=z;         
    var iframe = document.getElementById('gameFrame');
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage({kind:"updateBackground",data:this.room.background3d[this.selectIdx],idx:this.selectIdx}, "*");
   }
   public saveModelBackground(){
    let x=this.background3dForm.controls['x'].value;
    let y=this.background3dForm.controls['y'].value;
    let z=this.background3dForm.controls['z'].value;

    this.room.background3d[this.selectIdx].y=y;         
    this.room.background3d[this.selectIdx].x=x;         
    this.room.background3d[this.selectIdx].z=z;         
    this._companyService.updateRoom(this.room);
    Swal.fire({title:'Sucesso',text:'Sala atualizada.'}) 
   }   
   
  
  public choose2dImage(idx){
    this.src2d=this.room.background2d[idx].bg;
    this.selectIdx=idx;
    this._appData.spaceToEdit=idx;
    $('#editRoomMenu').click();
    this.background2dForm = this.fb.group({
      x : this.room.background2d[idx].x,
      y: this.room.background2d[idx].y,
    });
    var iframe = document.getElementById('gameFrame');
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage({kind:"updateBackground",data:{x:this.room.background2d[idx].x,y:this.room.background2d[idx].y,idx:Number(this.selectIdx)}}, "*");

  }
   public update2dBackground(){
    let x=this.background2dForm.controls['x'].value;
    let y=this.background2dForm.controls['y'].value;
    this.room.background2d[this.selectIdx].y=y;         
    this.room.background2d[this.selectIdx].x=x;         
    var iframe = document.getElementById('gameFrame');
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage({kind:"updateBackground",data:{x:x,y:y,idx:Number(this.selectIdx)}}, "*");
   }
   public save2dBackground(){
    let x=this.background2dForm.controls['x'].value;
    let y=this.background2dForm.controls['y'].value;
    this.room.background2d[this.selectIdx].y=y;         
    this.room.background2d[this.selectIdx].x=x;     
    this._companyService.updateRoom(this.room);
    Swal.fire({title:'Sucesso',text:'Sala atualizada.'}) 
   }   
    public saveBackground(i){
        let x0=this.vecBackgroundForm[i].form.controls['x0'].value;
        let y0=this.vecBackgroundForm[i].form.controls['y0'].value;
        let x1=this.vecBackgroundForm[i].form.controls['x1'].value;
        let y1=this.vecBackgroundForm[i].form.controls['y1'].value;
        let spastr=this.vecBackgroundForm[i].form.controls['spa'].value;
        let vspa=spastr.split(',');
        let spa=[]
        vspa.forEach(t=>{
          spa.push(Number(t))
        })
        if (spa.length==0){
          spa.push(i)
        }
        this.room.spaces[i].x0=x0
        this.room.spaces[i].y0=y0;         
        this.room.spaces[i].x1=x1
        this.room.spaces[i].y1=y1;  
        this.room.spaces[i].spa=spa;       
        
      this._companyService.updateRoom(this.room);
      Swal.fire({title:'Sucesso',text:'Sala atualizada.'})
    }

    public selectThumbnail(item){
      if (item.name!="NOVO"){
        this.texture=item.name;
      }
      else{
        Swal.fire({
          title: 'Selecione uma categoria para adicionar imagem',
          input: 'select',
          inputOptions: {
              doors: 'doors',
              sittables: 'sittables',
              plants: 'plants',
              tables: 'tables',
              stands: 'stands',
              people: 'people',
              armoires: 'armoires',
              luminaires: 'luminaires',
              floor: 'floor',
              sculptures: 'sculptures',
              paintings: 'paintings',
              containers: 'containers',
              decorations: 'decorations',
              buildings: 'buildings'
            },
          inputPlaceholder: 'Select a category',
          showCancelButton: true,
          inputValidator: (value) => {
              if (value) {
                this.category=value;
                $('#textureAdd').click();

              } 
          }
        })
        
      }
    }
    public deleteObject(){
      let room=this.room;
      let object=this._appData.object;
      let arrayOfObjects=room.roomObjects
      for (var i = 0; i < arrayOfObjects.length; i++) {
        var obj = arrayOfObjects[i];
        if (obj.objectId == object.objectId) {
            arrayOfObjects.splice(i, 1);
        }
      }
      room.roomObjects=arrayOfObjects;
      this._companyService.getRoom(object.room).set(room).then(val=>{
        var iframe = document.getElementById('gameFrame')
        var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
        iWindow.location.reload();
        $('#editObjectModal').modal('hide');
      })

    
    }
    public saveObject(){
     /* let x=this.dimensionForm.controls['x'].value;
      let y=this.dimensionForm.controls['y'].value;
      let z=this.dimensionForm.controls['z'].value;
      let action=this.otherForm.controls['action'].value;
      let link=this.otherForm.controls['link'].value;
      let collision=this.otherForm.controls['collision'].value;
    
      this._appData.object.dimensions={x:x,y:y,z:z}
      this._appData.object.action=action;
      this._appData.object.link=link;
      this._appData.object.collision=collision;
      this._appData.object.texture=this.texture;

      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;

      if (!this._appData.object.objectId){
        let date=new Date();
        this._appData.object.objectId=date.getTime();
        iWindow.postMessage({kind:"addObject",object:this._appData.object}, "*");

      }
      else{
        iWindow.postMessage({kind:"updateObject",object:this._appData.object}, "*");
      }


      this._appData.object=null;
      $('#editObjectModal').modal('hide');
*/
    }

    public ngOnDestroy() : any {
    }
    public backgroundTextureAdd(str){
      this.imageToChange=str;
      $('#backgroundTextureAdd').click();
    }
    public textureAddFileEvent(fileInput: any){
      var file = fileInput.target.files[0];
      let date=new Date();
      let newfile = this.imageToChange+'.png';
     // if (this.imageToChange.indexOf('map')==0){
        newfile=this.imageToChange+'.png'
        this._auth.uploadToFirebase(file, newfile, 'events/'+this._appData.event.id.toString()+'/rooms/'+this._appData.room.id+'/').subscribe(snapshot =>{
          snapshot.ref.getDownloadURL().then(url => {
            let finalURL = url;
            let linha=this.imageToChange.indexOf('-')
            let idx=this.imageToChange.substring(linha+1);

            let x0=this.vecBackgroundForm[idx].form.controls['x0'].value;
            let y0=this.vecBackgroundForm[idx].form.controls['y0'].value;
            let x1=this.vecBackgroundForm[idx].form.controls['x1'].value;
            let y1=this.vecBackgroundForm[idx].form.controls['y1'].value;


            this.room.background[idx].x0=x0  
            this.room.background[idx].y0=y0  
            this.room.background[idx].x1=x1  
            this.room.background[idx].y1=y1  

            var iframe = document.getElementById('gameFrame')
            var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
            if (this.backgroundType=='2D'){
              this.room.background[idx]={img:url,x:0,y:0};      
              iWindow.postMessage({kind:"addBackground",x:0,y:0,background:url}, "*");
            }
            else if (this.backgroundType=='Photo'){
              this.room.background[idx].photo={img:url,ra:5,ry:0,kind:'sphere'};      
              let ra=this.vecBackgroundForm[idx].form.controls['ra'].value;
              let ry=this.vecBackgroundForm[idx].form.controls['ry'].value;
  
              iWindow.postMessage({kind:"addBackground",x0:x0,y0:y0,x1:x1,y1:y1,idx:idx,photo:{img:url,ra:ra,ry:ry}}, "*");
            }
            this._companyService.getRoom(this._appData.room.id).set(this.room)
            Swal.fire({title:'Adicionado'})
        })
    
        });
      //}
/*      else{
        this._auth.uploadToFirebase(file, newfile, 'events/'+this._appData.event.id.toString()+'/user/'+this._appData.instagramUser.uid+'/'+this._appData.room.id+'/').subscribe(snapshot =>{
          snapshot.ref.getDownloadURL().then(url => {
            let finalURL = url;
            if (this.imageToChange=='background'){
              this.room.textures['background']=url;
              this.updateMyItem();
            }
            if (this.imageToChange=='imageBackground'){
              this.room.photoBackground=url;
            }
            this._companyService.getRoom(this._appData.room.id).set(this.room).then((val)=>{
              //reload iframe
              var iframe = document.getElementById('gameFrame')
              var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
              iWindow.location.reload();
            })
    
        })
    
        });
  
      }*/
    }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/edit-room-modal/edit-room-component.ts